import global from "../global.js";
import Menu from "../Menu.js";
import Placeholder from "../scene/Placeholder.js";
import Placer from "../scene/Placer.js";
import Resource from "../scene/drivers/Resource.js";
import Attachment from "../scene/drivers/Attachment.js";
import LoadingMediaArea from "../ui/LoadingMediaArea.js";

//import InputTextArea    from "../ui/InputTextArea.js";

const d3 = global.d3;
const log = global.log.getLogger("f_mtac.ui.ResourcesArea");
log.setLevel(log.levels.WARN);

let ResourcesArea = function () {
    let svg;
    let interaction_end = () => {
        Menu.set_close_handler("resources_tools_area", null);
        Menu.close("resources_tools_area");
        $("body").off("click.resources_area.resource");
    };
    this.init = function () {
        const tools = global.tools;
        const scene = global.scene;

        let resources_area = $("<div />").attr({
            id: "resources_area"
        });

        Menu.create({
            name: "resources_tools_area",
            contents: ["#resources_tools"],
            frame_content: resources_area,
            close_timer: true
        });

        tools.register_group({
            name: "resources_categories",
            target: "$view",
            enable: (_, selected) => {
                this.switch_category(selected.data.category);
            },
            disable: (_, selected) => {
                this.switch_category(selected.data.category);
            }
        });

        let categories = global.resources.categories.sort();
        log.debug("Resource caterories:", categories);
        for (let category_name of categories) {
            tools.register({
                group: "resources_categories",
                data: {category: category_name},
                name: `resource-category-${category_name}`,
                icon: global.resources.category["_categories"][category_name],
                position: "#resources_tools"
            });
        }

        tools.register({
            name: "resource_drop",
            icon: "add_resource",
            position: "#command_resources_area",
            enable: () => {},
            disable: () => {
                if (this.interaction !== null) {
                    this.interaction.cancel();
                }
            },
            data: {
                active_resource: null,
                placeholder: new Placeholder(scene.objects.layers.resources.group, "resource")
            },
            draggable: {
                start: (data, tool) => {
                    let {x: ox, y: oy} = tool.get_container_position();
                    data.origin = {
                        ox: 100 * scene.root_transform.k - ox,
                        oy: 100 * scene.root_transform.k - oy
                    };
                    let {x, y} = scene.transform_coordinates(d3.event, data.origin);
                    data.placeholder.init({
                        color: scene.map.grid.configuration.get("grid.color")
                    });
                    data.placeholder.move_to({x, y});
                },
                drag: (data) => {
                    let {x, y} = scene.transform_coordinates(d3.event, data.origin);
                    data.placeholder.move_to({x, y});
                },
                end: (data, tool) => {
                    if (tool.is_inside(data.placeholder.handle.node())) {
                        data.placeholder.end();
                        return Promise.resolve();
                    }
                    return this.interact({category: this.category}).then((resource) => {
                        if (resource === null) {
                            data.placeholder.end();
                            return;
                        }
                        let {x, y} = data.placeholder.indicator_position;
                        data.active_resource = new Resource(scene.objects.layers.resources.group, resource);
                        data.active_resource.draw(x, y);

                        // position of the resource is the position of the indicator
                        data.active_resource.update(x - 100, y - 100);

                        // scene.resource_update_coordinates(data.active_resource);
                        data.placeholder.end();
                        global.resources.color(data.active_resource.handle, global.resources.color_by_name["green"].value);

                        if (data.active_resource.handle.select("g.animated_resource").node() !== null || data.active_resource.handle.select(".no-status").node() !== null) {
                            global.resources.color(data.active_resource.handle, global.resources.attachment_color_by_name["gray"].value);
                            data.active_resource.handle.select("g.color").attr("visibility", "hidden");
                        }
                        return global.resources.request_name(data.active_resource.handle).then((name) => {
                            if (name === null) {
                                data.active_resource.handle.remove();
                                data.active_resource = null;
                                return;
                            }
                            scene.objects.meta_create("resources", data.active_resource);
                            data.active_resource = null;
                        });
                    });
                }
            }
        });
        tools.register({
            name: "attachment_drop",
            icon: "trombone_add",
            position: "#command_resources_area",
            enable: () => {},
            disable: () => {
                if (this.interaction !== null) {
                    this.interaction.cancel();
                }
            },
            data: {
                active_attachment: null,
                placeholder: new Placeholder(scene.objects.layers.resources.group, "media")
            },
            draggable: {
                start: (data, tool) => {
                    let {x: ox, y: oy} = tool.get_container_position();
                    data.origin = {
                        ox: 100 * scene.root_transform.k - ox,
                        oy: 100 * scene.root_transform.k - oy
                    };
                    let {x, y} = scene.transform_coordinates(d3.event, data.origin);
                    data.placeholder.init({
                        color: scene.map.grid.configuration.get("grid.color")
                    });
                    data.placeholder.move_to({x, y});
                },
                drag: (data) => {
                    let {x, y} = scene.transform_coordinates(d3.event, data.origin);
                    data.placeholder.move_to({x, y});
                },
                end: async (data, tool) => {
                    if (tool.is_inside(data.placeholder.handle.node())) {
                        data.placeholder.end();
                        return Promise.resolve();
                    }
                    let attachment = await this.select({file: undefined});
                    if (LoadingMediaArea.interaction !== null) {
                        LoadingMediaArea.interaction.close();
                    }
                    if (attachment === null) {
                        data.placeholder.end();
                        return;
                    }
                    let {x, y} = data.placeholder.indicator_position;
                    let type = attachment.media_data.type.split("/")[0];
                    let media_category = "pj_text";
                    switch (type) {
                        case "image":
                            media_category = "pj_image";
                            break;
                        case "audio":
                            media_category = "pj_audio";
                            break;
                        case "video":
                            media_category = "pj_video";
                            break;
                    }
                    data.active_attachment = new Attachment(scene.objects.layers.resources.group, global.resources.category["_placeholder"][media_category].cloneNode(true), attachment /*attachment.cloneNode(true)*/);
                    data.active_attachment.draw(x, y);
                    let {x: cx, y: cy} = data.active_attachment.center();
                    data.active_attachment.update(x + (x - cx), y + (y - cy));
                    data.placeholder.end();
                    global.resources.color(data.active_attachment.handle, global.resources.attachment_color_by_name["gray"].value);
                    return global.resources
                        .request_name(data.active_attachment.node, global.internationalization.text("media.Attachment-name"), global.internationalization.text("media.Attachment-name-shall-not-exceed-number-char", {number: "36"}))
                        .then((name) => {
                            if (name === null) {
                                data.active_attachment.handle.remove();
                                data.active_attachment = null;
                                return;
                            }
                            scene.objects.meta_create("resources", data.active_attachment);
                            data.active_attachment = null;
                        });
                }
            }
        });

        tools.register({
            name: "resource_remove",
            icon: "banc",
            position: "#command_resources_area",
            data: {
                active_resource: null,
                placer: new Placer(scene.objects.layers.resources.group)
            },
            draggable: {
                start: (data, tool) => {
                    data.active_resource = scene.resources_stack.pop();
                    data.active_media = scene.medias_stack.pop();
                    if (data.active_resource === undefined) {
                        data.active_resource = null;
                        return;
                    }
                    let {x: ox, y: oy} = tool.get_container_position();
                    data.origin = {
                        ox: 100 * scene.root_transform.k - ox,
                        oy: 100 * scene.root_transform.k - oy
                    };
                    let {x, y} = scene.transform_coordinates(d3.event, data.origin);

                    scene.objects.restore("resources", data.active_resource);
                    data.placer.init({color: scene.map.grid.configuration.get("grid.color")});
                    data.active_resource.handle.select("g.node").classed("dragged", true);
                    data.active_resource.move_to({x, y});
                    data.placer.move_to({x, y});
                },
                drag: (data) => {
                    if (data.active_resource === null) {
                        return;
                    }
                    let {x, y} = scene.transform_coordinates(d3.event, data.origin);
                    data.active_resource.move_to({x, y});
                    data.placer.move_to({x, y});
                },
                end: async (data, tool) => {
                    var space = global.storage.selected_space;
                    if (data.active_resource === null) {
                        return;
                    }
                    if (tool.is_inside(data.active_resource.handle.node())) {
                        data.placer.end();
                        scene.resources_stack.push(data.active_resource);
                        let media_id = data.active_resource.node.attr("data-media");
                        if (media_id !== null) {
                            let media = await space.media_retrieve({local_id: media_id});
                            if (media !== undefined) {
                                scene.medias_stack.push(media);
                            }
                        }
                        scene.objects.tx_delete("resources", data.active_resource);
                        data.active_resource = null;
                        data.active_media = null;
                        return;
                    }
                    data.active_resource.handle.select("g.node").classed("dragged", false);
                    let {x: ox, y: oy} = data.placer.indicator_position;
                    let {x: cx, y: cy} = data.active_resource.center("g.figure");
                    data.active_resource.move({x: ox - cx, y: oy - cy});
                    data.placer.end();
                    if (data.active_media !== undefined && data.active_media !== null) {
                        data.active_media.media_hash = undefined; //to commit the restored media
                        space.media_create(data.active_media);
                    }
                    scene.objects.publish("resources", data.active_resource);

                    data.active_resource = null;
                    data.active_media = null;
                    return;
                }
            }
        });

        svg = d3.select("#resources_area").append("svg").attr("viewBox", "0 0 1400 600");
    };

    global.app.bootstrap.register_module({
        name: "ui_resources_area_tools",
        deps: ["dom_loaded", "tools", "scene", "resources_loaded"],
        init: async () => {
            this.init();
        }
    });

    this.selected = null;
    this.category = undefined;
    this.switch_category = function (category) {
        this.category = category;
        let x = 0,
            y = 0,
            S = 200,
            N = 7;
        svg.html("");
        let resource_names = Object.keys(global.resources.category[category]).sort();
        for (let resource_name of resource_names) {
            let resource = svg.append(() => global.resources.category[category][resource_name]);
            resource.attr("transform", `translate(${x},${y})`).attr("class", "resource_figure");
            y = x == S * (N - 1) ? y + S : y;
            x = (x + S) % (S * N);
        }
        svg.attr("viewBox", `0 0 ${N * S} ${Math.ceil(resource_names.length / N) * S}`);
    };
    this.interaction = null;
    this.interact = function ({category}) {
        let categories = global.resources.categories.sort();
        if (category === undefined) {
            category = categories[0];
            this.category = category;
        }
        return new Promise((resolve) => {
            this.interaction = {
                cancel: () => {
                    interaction_end();
                    resolve(null);
                    this.interaction = null;
                }
            };
            global.tools.group_select("resources_categories", `resource-category-${category}`);
            Menu.display(["resources_tools_area"]);
            $("body").on("click.resources_area.resource", "#resources_area .resource_figure", (event) => {
                this.selected = event.currentTarget;
                interaction_end();
                resolve(this.selected);
                global.tools.tool_unselect("resource_drop");
            });
            Menu.set_close_handler("resources_tools_area", () => {
                this.selected = null;
                interaction_end();
                resolve(this.selected);
                global.tools.tool_unselect("resource_drop");
            });
        });
    };
    this.select = async function ({file}) {
        var media = null;
        if (file !== undefined) {
            media = await global.medias.handle_file(file);
        } else {
            media = await global.medias.interact({
                accept: "*.*"
            });
        }
        if (media === null) {
            return media;
        }
        return media;
    };
};

export default new ResourcesArea();
